import React, {forwardRef, Ref, useEffect, useImperativeHandle, useState} from "react";
import {Modal} from 'react-bootstrap'
import Draggable from "react-draggable";
import DraggableComponent from "../../Components/DraggableComponent";
import { IGridToolBox } from "../../Components/IInterfaces";
// import az from '../../images/az.svg'
// import maskgrid from '../../../images/images/maskgrid.svg'
import download from '../../images/download.svg'
import clean from '../../images/clean.svg'
import '../InterchangeApplication/Interchange.css'

interface IProps {
    message?: string;
    api?: any;
    hellTest?: () => void
    onClear?: () => void
    exportCSV?: () => void
}


const InspectionGridToolbar = forwardRef((props: any, ref: Ref<IGridToolBox>) => {
    let totalRows: number = 0;
    let pageSize: number = 500;
    let totalPages: number = 0;
    let currPage: number = 1;
    let totalRowsAfterFilter: number = 0;

    var pageindicator = "";


    const [pages, setPages] = useState('');
    const [showSortPopup, setShowPopup] = useState(false);
    const [showColumnPopup, setShowColumnPopup] = useState(false);
    const [columns, setColumns] = useState([]);
    const [sortColumns1, setSortColumns1] = useState<any>([]);
    const [page1, setPage1] = useState('');
    const [avlColumns, setAvlColumns] = useState([]);
    const [selColumns, setSelColumns] = useState([]);


    useEffect(() => {
        if (props && props.api && props.api.rowModel && props.api.rowModel.rootNode && props.api.rowModel.rootNode.allLeafChildren) {
            displayPageInformation();
        }

    }, [props.rowData]);

    let displayPageInformation = () => {
        totalRows = props.api.rowModel.rootNode.childrenAfterFilter.length;
        totalRowsAfterFilter = totalRows;
        pageSize = (props.pageSize) ? props.pageSize : 100;
        if (totalRows == 0) {
            totalPages = 0;
        } else {
            totalPages = Math.ceil(totalRows / pageSize);
        }
        if (totalRows == 0) {
            pageindicator = (0) + "-" + (0) + " of " + 0;
        } else {
            pageindicator = (((pageSize * currPage) - pageSize) + 1) + "-" + ((pageSize * currPage) > totalRows ? totalRows : (pageSize * currPage)) + " of " + totalRows;
        }
        setPages(pageindicator);
    }

    useImperativeHandle(ref, () => ({passColumnFilter}))

    const passColumnFilter = (params: any) => {
        totalRows = params.api.rowModel.rootNode.childrenAfterFilter.length;
        totalRowsAfterFilter = totalRows;
        pageSize = (props.pageSize) ? props.pageSize : 100;
        if (totalRows == 0) {
            totalPages = 0;
        } else {
            totalPages = Math.ceil(totalRows / pageSize);
        }
        if (totalRows == 0) {
            pageindicator = (0) + "-" + (0) + " of " + 0;
        } else {
            pageindicator = (((pageSize * currPage) - pageSize) + 1) + "-" + ((pageSize * currPage) > totalRows ? totalRows : (pageSize * currPage)) + " of " + totalRows;
        }
        setPages(pageindicator);
    }

    let gotoNextPage = () => {
        if (props.api) {
            props.api.paginationGoToNextPage();
            currPage = props.api.paginationGetCurrentPage();
            //console.log(currPage);
            currPage = currPage + 1;
            displayPageInformation();
        }
    }
    let gotoPreviousPage = () => {
        if (props.api) {
            props.api.paginationGoToPreviousPage();
            currPage = props.api.paginationGetCurrentPage();
            // console.log(currPage);
            currPage = currPage + 1;
            displayPageInformation();
        }
    }
    let onSearchFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // console.log(e.currentTarget.value);
        if (props.api && props.api.setQuickFilter) {
            props.api.setQuickFilter(e.currentTarget.value);
            // console.log(props.api.rowModel.rootNode.childrenAfterFilter.length);
            displayPageInformation();
            // allChildrenCount
        }
    }

    let onClickRemoveSearch = () => {
        props.api.setQuickFilter("");
        // console.log(props.api.rowModel.rootNode.childrenAfterFilter.length);
        displayPageInformation();
    }

    let onClickSort = () => {
        //console.log("Sort");
        setShowPopup(true);
        var colArray: object[] = [];
        var colObject: object = {};
        //console.log(props.api.getColumnDefs());
        var cols: any = [];
        var columns: any = props.api.getColumnDefs();
        columns.forEach((column: any, idx: number) => {
            if (column.sort && !column.hide) {
                var colObj: any = {};
                colObj.text = column.headerName;
                colObj.field = column.field;
                colObj.sort = column.sort;
                cols.push(colObj);
            }
        });

        setSortColumns1(cols);
        setColumns(columns);
    }
    let onClosePopup = () => {
        setShowPopup(false);
    }

    let onClickClear = () => {
        props.onClear();
    }

    let onClickExport = () => {
        props.exportCSV();
    }

    let onClickAdd = () => {
        props.onClickAdd();
    }


    let onAddBtnClickHandler = () => {
        // var sArr = this.state.sortableColumns;
        if (document.getElementById("organizeColumnsSelect")) {
            //var sortColumns:any = sortColumns;
            var element: any = document.getElementById("organizeColumnsSelect")
            var field = element.value;
            if (field) {
                var text = element.options[element.selectedIndex].text;
                var colObj: any = {};
                colObj.text = text;
                colObj.field = field;
                colObj.sort = "asc";
                sortColumns1.push(colObj);
                setSortColumns1(sortColumns1);
                setPage1("" + Math.random() * 1000000);
            }
        }
    }

    let onDescSort = (e: any, field: any) => {
        //console.log(e,field);
        // var sArr = this.state.sortableColumns;
        for (var i = 0; i < sortColumns1.length; i++) {
            if (sortColumns1[i].field == field) {
                sortColumns1[i].sort = e.target.checked ? "desc" : "asc"
                break;
            }
        }
        setSortColumns1(sortColumns1);
        setPage1("" + Math.random() * 1000000);
    }
    let onDelSort = (field: any) => {
        // var sArr = this.state.sortableColumns;
        for (var i = 0; i < sortColumns1.length; i++) {
            if (sortColumns1[i].field == field) {
                sortColumns1.splice(i, 1);
                break;
            }
        }
        setSortColumns1(sortColumns1);
        setPage1("" + Math.random() * 1000000);
        // this.setState({sortableColumns:sArr});
    }
    let onSaveSort = () => {
        //console.log(sortColumns1);
        var sortArr: any = [];
        for (var i = 0; i < sortColumns1.length; i++) {
            var obj: any = {};
            obj.colId = sortColumns1[i].field;
            obj.sort = sortColumns1[i].sort;
            obj.sortIndex = i;
            sortArr.push(obj);
        }
        //sortArr.push({colId: 'model', sort: 'asc'});
        props.api.rowModel.columnApi.applyColumnState({
            state: sortArr,
            defaultState: {sort: null},
        });
        onClosePopup();
    }

    let onCloseColumnPopup = () => {
        setShowColumnPopup(false);
    }


    let onClickShowColumns = () => {
        setShowColumnPopup(true);
        var selectedCols: any = [];
        var avlCols: any = [];
        var columns: any = props.api.getColumnDefs();
        columns.forEach((column: any, idx: number) => {
            var colObj: any = {};
            if (!column.hide) {
                colObj.text = column.headerName;
                colObj.field = column.field;
                selectedCols.push(colObj);
            } else {
                colObj.text = column.headerName;
                colObj.field = column.field;
                avlCols.push(colObj);
            }
        });
        setSelColumns(selectedCols);
        setAvlColumns(avlCols);
        setPage1("" + Math.random() * 1000000);
    }

    let onClickRight = () => {
        var items: any = document.getElementById("leftId");
        if (items && items.options) {
            var avlCols: any = [];
            var selectedCols: any = selColumns;

            for (var k = 0; k < items.options.length; k++) {
                var colObj: any = {};
                colObj.text = items.options[k].text;
                colObj.field = items.options[k].value;
                if (items.options[k].selected == true) {
                    selectedCols.push(colObj);
                } else {
                    avlCols.push(colObj);
                }
            }

            setAvlColumns(avlCols);
            setSelColumns(selectedCols);
            setPage1("" + Math.random() * 1000000);
        }
    }

    let onClickUpRows = () => {

        var arr: any = document.querySelectorAll("#rightId option");
        var box: any = document.getElementById("rightId");
        let findSelected = selColumns.findIndex((sel:any)=>sel.selected === true);

        if (findSelected === 0) {
            return;
        }

        var indexes = [];
        for (var k = 0; k < arr.length; k++) {
            if (arr[k].selected)
                indexes.push(arr[k].value);
        }

        var arrayTemp: [] = swapElement(selColumns, indexes, "dec");

        setSelColumns([...arrayTemp]);
        setPage1("" + Math.random() * 1000000);


      
    }
    let swapElement = (array: any, indexes: any, str: any): any => {
        var tmp = "";

        var arr: any = [];

        if (str == "inc") {
            for (var k = indexes.length - 1; k >= 0; k--) {
                for (var j = array.length - 1; j >= 0; j--) {
                    if (array[j].field == indexes[k]) {
                        arraymove(array, j, j + 1);
                        break;
                    }
                }
            }
        } else {
            for (var k = 0; k < indexes.length; k++) {
                for (var j = 0; j < array.length; j++) {
                    if (array[j].field == indexes[k]) {
                        arraymove(array, j, j - 1);
                        break;
                    }
                }
            }
        }

        return array;
    }

    let arraymove = (arr: any, fromIndex: number, toIndex: number) => {
        var element = arr[fromIndex];
        element.selected = true;
        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);
        // return arr;
    }

    let onClickDown = () => {
        var arr: any = document.querySelectorAll("#rightId option");
        var box: any = document.getElementById("rightId");
        let selected = selColumns.filter((sel:any)=>sel.selected === true) || [];

        let obj: any = selected.slice(-1)[0]
        let findSelected = selColumns.findIndex((sel:any)=>sel === obj);
        if (findSelected + 1 === selColumns.length) {
            return;
        }
        var indexes = [];
        for (var k = 0; k < arr.length; k++) {
            if (arr[k].selected)
                indexes.push(arr[k].value);
        }

        var arrayTemp: [] = swapElement(selColumns, indexes, "inc");

        setSelColumns([...arrayTemp]);
        setPage1("" + Math.random() * 1000000);

    }

    let onClickLeft = () => {
        var items: any = document.getElementById("rightId");
        if (items && items.options) {
            //console.log(items.options.length);
            var selItem = [];
            var avlCols: any = avlColumns;
            var selectedCols: any = [];
            //console.log(items);
            for (var k = 0; k < items.options.length; k++) {
                var colObj: any = {};
                colObj.text = items.options[k].text;
                colObj.field = items.options[k].value;
                if (items.options[k].selected == true) {
                    avlCols.push(colObj);
                } else {
                    selectedCols.push(colObj);
                }
            }
            setAvlColumns(avlCols);
            setSelColumns(selectedCols);
            setPage1("" + Math.random() * 1000000);
            //console.log(selItem);
        }


     
    }

    let onSaveShowHide = () => {
       
        var cols: any = [];
        if (selColumns.length > 0) {
            selColumns.forEach((col: any, idx: number) => {
                cols.push(col.field);
            });
            props.api.columnModel.setColumnsVisible(cols, true);
        }
        props.api.columnModel.moveColumns(cols, 0);
        if (avlColumns.length > 0) {
            cols = [];
            avlColumns.forEach((col: any, idx: number) => {
                cols.push(col.field);
            });
            props.api.columnModel.setColumnsVisible(cols, false);
        }


        onCloseColumnPopup();
    }

    const selectedOption = (e:any, idx:number) => {
        let options : any = [...selColumns]

        if(e.ctrlKey){
            if(options[idx].selected === true){
                options[idx].selected = false;
            }else{
                options[idx].selected = true;
            }
        }else{
            //console.log('no 17')
            options.map(function(x:any) {
                x.selected = false;
            });
            options[idx].selected = true;
        }

        setSelColumns(options);
    }



    return (
        <div>
            <Draggable handle=".modal-header">
                <Modal show={showColumnPopup} dialogAs={DraggableComponent} bgSize='lg' className="fcPopup">
                    <div className="modal-content" style={{"width": "800px", "height": "400px"}}>
                        <div className="modal-header modalPopupHeader">
                            <h6 className="modal-title">{"Column Show/Hide"}</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                    style={{marginLeft:"0px"}} onClick={onCloseColumnPopup}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div id="organizeColumns" className="tab-pane">
                                <div className="row">
                                    <div className="col-md-5">
                                        <div className="panel panel-default customPanel">
                                            <div className="panel-heading removeHeaderBackground" style={{
                                                paddingLeft: "0px",
                                                fontSize: "14px",
                                                paddingBottom: "5px"
                                            }}>{"Available Columns"}</div>
                                            <div className="tablePanel"
                                                 style={{height: "220px", overflowY: "hidden", msOverflowX: 'hidden'}}>
                                                <select multiple={true} id="leftId" className="tabSelect form-select"
                                                        style={{
                                                            "paddingLeft": "2px",
                                                            "width": "100%",
                                                            "height": "100%",
                                                            "border": "dashed",
                                                            "borderStyle": "ridge"
                                                        }}>
                                                    {
                                                        avlColumns.map((item: any, idx: number) => {
                                                            var list = <option value={item.field}>{item.text}</option>;
                                                            return list;

                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-1" style={{paddingTop: "100px"}}>
                                        <button className="btn cbtn-success grid-button" style={{marginBottom:"5px"}}
                                                type="button" onClick={onClickLeft}>
                                            <i className="fa fa-arrow-left" style={{color:"#FFF"}}></i>
                                        </button>

                                        <button className="btn cbtn-success grid-button" type="button" onClick={onClickRight}>
                                            <i className="fa fa-arrow-right" style={{color:"#FFF"}}></i>
                                        </button>
                                    </div>
                                    <div className="col-md-5">
                                        <div className="panel panel-default customPanel">
                                            <div className="panel-heading removeHeaderBackground" style={{
                                                paddingLeft: "0px",
                                                fontSize: "14px",
                                                paddingBottom: "5px",
                                                fontWeight:"bold"
                                            }}>{"Selected Columns"}</div>
                                            <div className="tablePanel"
                                                 style={{height: "220px", overflowX: "hidden", overflowY: 'hidden'}}>
                                                <select multiple={true} id="rightId" className="tabSelect form-select"
                                                        style={{
                                                            "paddingLeft": "2px",
                                                            "width": "100%",
                                                            "height": "100%",
                                                            "border": "dashed",
                                                            "borderStyle": "ridge"
                                                        }}>
                                                    {
                                                        selColumns.map((item: any, idx: number) => {
                                                            var list = <option value={item.field} onClick={(e)=>{selectedOption(e,idx)}}
                                                                               selected={item.selected ? true : false}>{item.text}</option>;
                                                            return list;

                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-1" style={{paddingTop: "100px"}}>
                                        <button className="btn btn-default btn-xs showHideButtonsClass" type="button"
                                                onClick={onClickUpRows}><i className="fa fa-arrow-up"></i></button>
                                        <button className="btn btn-default btn-xs showHideButtonsClass" type="button"
                                                onClick={onClickDown}><i className="fa fa-arrow-down"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={onCloseColumnPopup}
                                    className="btn btn-outline-dark text-dark cbtn">{"Close"}</button>
                            <button type="button" onClick={onSaveShowHide} className="btn btn-success cbtn">{"Save"}</button>
                        </div>
                    </div>
                </Modal>
            </Draggable>
            <Draggable handle=".modal-header">
                <Modal show={showSortPopup} bgSize='lg' dialogAs={DraggableComponent} className="fcPopup">
                    <div className="modal-content" style={{"width": "600px", "height": "400px"}}>
                        <div className="modal-header modalPopupHeader">
                            <h6 className="modal-title">{"Column Sort"}</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                    onClick={onClosePopup} style={{marginLeft:"0px"}}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div id="organizeColumns" className="tab-pane">
                                <div className="row">
                                    <div className="col-md-1"></div>
                                    <div className="col-md-8">
                                        <select id="organizeColumnsSelect" className="form-select pull-right"
                                                style={{width: "100%", height: "34px"}}>
                                            {
                                                columns.map((item: any, idx: number) => {
                                                    var list: any = "";
                                                    var flag: boolean = false;
                                                    sortColumns1.map((sItem: any, sIdx: number) => {
                                                        if (sItem.field == item.field) {
                                                            flag = true;
                                                        }
                                                    })
                                                    if (!flag) {
                                                        list = <option value={item.field}>{item.headerName}</option>;
                                                        return list;
                                                    }
                                                })
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <button type="button" className="btn cbtn-success cbtn"
                                                onClick={onAddBtnClickHandler}>{"Add"}</button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="container" style={{height: "220px", overflow: "auto"}}>
                                        <table className="table table-bordered mt-1" style={{fontSize: "14px"}}>
                                            <thead>
                                            <tr>
                                                <th>Column Heading</th>
                                                <th>Desc</th>
                                                <th>Operation</th>
                                            </tr>
                                            </thead>
                                            <tbody className="clickableRow">
                                            {
                                                sortColumns1.map((m: any, index: number) => {
                                                    if (m.text)
                                                        return <tr>
                                                            <td> {m.text}</td>
                                                            <td><input type="checkbox"
                                                                       checked={m.sort == "desc" ? true : false}
                                                                       style={{"width": "20px", "height": "20px"}}
                                                                       onClick={(e) => {
                                                                           onDescSort(e, m.field)
                                                                       }}/></td>
                                                            <td>
                                                                <button type="button" className="btn btn-default"
                                                                        onClick={(e) => {
                                                                            onDelSort(m.field)
                                                                        }}><i className="fas fa-remove"></i></button>
                                                            </td>
                                                        </tr>;
                                                })
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={onClosePopup} className="btn btn-outline-dark text-dark cbtn">{"Close"}</button>
                            <button type="button" onClick={onSaveSort}
                                    className="btn cbtn  btn-success">{"Save"}</button>
                        </div>

                    </div>
                </Modal>
            </Draggable>
            <div className="data-table" style={{display:props.hideToolbar ? "none":""}}>
                <div className="row" style={{backgroundColor:'white'}}>
                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-12">
                    <div className="form-group has-search mb-0">
                        <span className="fa fa-search form-control-feedback"></span>
                        <input type="text" className="form-control rounded-2" placeholder="Search Here" onChange={onSearchFilterChange}/>
                      </div>
                    </div>


                    <div className="col-xl-9 col-lg-8 col-md-8 col-sm-12 text-end insp-tollbar mb-3">
                       <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            {props.showButton?<button className="btn btn-success waves-effect waves-light p-2 m-m-b-15 rounded-2" onClick={onClickAdd} title={props.tip}> <i className="fa-solid fa-plus mx-1"></i> <span><b>{props.name}</b></span></button>
 : ""}
                            <div className="btn-group grid-nav mx-5 " role="group" aria-label="First group">
                                <button type="button" style={{padding: "0.5rem 1rem"}} className="btn btn-outline-secondary rounded-left" onClick={onClickSort} title={"Sort"}><img src="../../images/sort.svg" /></button>
                                <button type="button" className="btn btn-outline-secondary rounded-0" onClick={onClickShowColumns} title={"Columns Show/Hide"}><img src="../../images/show-hide.svg" /></button>
                                <button type="button" className="btn btn-outline-secondary rounded-0" onClick={onClickExport} title={"CSV Download"}><img src="../../images/download-file.svg" /></button>
                                <button type="button" className="btn btn-outline-secondary rounded-right" onClick={onClickClear} title={"Clear"}><img src="../../images/clear.svg"/></button>
                              </div>
                              <div className="text-end float-end">
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination float-end">
                                      <li className="page-item">
                                        <a className="page-link rounded-left btn-outline-secondary" onClick={gotoPreviousPage} aria-label="Previous">
                                          <span aria-hidden="true">&laquo;</span>
                                        </a>
                                      </li>
                                      <input type="text" className="form-control paginationText rounded-0"
                                       style={{width:'100px',height:'38px', textAlign:'center', borderLeft:'none', border:'1px solid #D0D5DD'}} value={pages}
                                       id="roles-table-pagination-count" readOnly/>
                                      <li className="page-item">
                                        <a className="page-link rounded-right btn-outline-secondary" onClick={gotoNextPage} aria-label="Next">
                                          <span aria-hidden="true">&raquo;</span>
                                        </a>
                                      </li>
                                    </ul>
                                  </nav>
                            </div>
                        </div>
                      
                       </div>
                    </div>
                </div>
            </div>
    </div>
    );
});

export default InspectionGridToolbar;
